import React, { Fragment, useContext, useEffect, useState } from "react";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { Link, useNavigate } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import Styles from "./home.module.css";
import DashboardTotalCustomer from "./DashCustomer/DashboardTotalCustomer";
import DashboardTotalSales from "./DashTotalSales/DashboardTotalSales";
import DashRewardReceived from "./DashRewardReceived/DashboardRewardReceived";
import DashboardRewardRedeem from "./DashRewardRedeem/DashboardRewardRedeem";
import CurrentGoldPrice from "./CurrentGoldPrice/CurrentGoldPrice";
import DashRecentCustomers from "./DashRecentCustomers/DashRecentCustomers";
import DashRecentOrderHistory from "./DashRecentOrderHistory/DashRecentOrderHistory";
import HistoryPriceGraph from "./HistoryPriceGraph";
import WeeklySalesReportGraph from "./WeeklySalesReportGraph";
// const HistoryPriceGraph = loadable(() => pMinDelay(import("./HistoryPriceGraph"), 1000));
// const WeeklySalesReportGraph = loadable(() => pMinDelay(import("./WeeklySalesReportGraph"), 1000));

function Home() {
  const { changeBackground } = useContext(ThemeContext);
  const [showWeeklySalesReport, setShowWeeklySalesReport] = useState(false);

  useEffect(() => {
    changeBackground({ value: "dark", label: "Dark" });
    const userData = localStorage.getItem("userDetails");
    if (userData) {
      const parsedData = JSON.parse(userData);
      setShowWeeklySalesReport(parsedData.role_permissions.sales_data);
    }
  }, []);

  return (
    <Fragment>
      <div className='row'>
        <div className='row'>
          <div className='col-sm-6 col-lg-3'>
            <div className='card overflow-hidden'>
              <DashboardTotalCustomer />
            </div>
          </div>
          <div className='col-sm-6 col-lg-3'>
            <div className='card overflow-hidden'>
              <DashboardTotalSales />
            </div>
          </div>
          <div className='col-sm-6 col-lg-3'>
            <div className='card overflow-hidden'>
              <DashRewardReceived />
            </div>
          </div>
          <div className='col-sm-6 col-lg-3'>
            <div className='card overflow-hidden'>
              <DashboardRewardRedeem />
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-lg-6 d-flex flex-column'>
            <div className='card'>
              <HistoryPriceGraph />
            </div>
            <div className='card'>
              <DashRecentOrderHistory />
            </div>
          </div>

          <div className='col-lg-6 d-flex flex-column'>
            <div className={`card d-flex justify-content-center mb-4 ${Styles.card}`}>
              <CurrentGoldPrice />
            </div>
            <div className={`card mb-4 ${Styles.customers_card}`}>
              <DashRecentCustomers />
            </div>
            {/* <div className='card'>
              <div className='card-body'>
                <WeeklySalesReportGraph />
              </div>
            </div> */}
            {showWeeklySalesReport && (
              <div className='card'>
                <div className='card-body'>
                  <WeeklySalesReportGraph />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default Home;
